import {
  compact,
  every,
  map,
  some,
  toUpper,
  uniq,
} from 'lodash';
import MarketMapper from '@/services/helpers/market-mapper';
import { parseSelectionsFromApi } from './special-markets-utils';

const { RESULTING_STATUS_TYPES } = MarketMapper;

export const resolveSpecialResultingStatus = (special) => {
  const topLevel = special?.resultingStatus;
  if (topLevel) return topLevel;

  const statuses = uniq(compact(map(parseSelectionsFromApi(special?.selections), 'resultingStatus')));
  if (!statuses.length) return RESULTING_STATUS_TYPES.NOT_RESULTED;
  if (some(statuses, (status) => status === RESULTING_STATUS_TYPES.PENDING_RESULTING)) {
    return RESULTING_STATUS_TYPES.PENDING_RESULTING;
  }
  if (some(statuses, (status) => status === RESULTING_STATUS_TYPES.RESULT_AMENDED)) {
    return RESULTING_STATUS_TYPES.RESULT_AMENDED;
  }
  if (every(statuses, (status) => status === RESULTING_STATUS_TYPES.RESULTED)) {
    return RESULTING_STATUS_TYPES.RESULTED;
  }
  if (some(statuses, (status) => status === RESULTING_STATUS_TYPES.RESULTED)) {
    return RESULTING_STATUS_TYPES.PENDING_RESULTING;
  }
  return statuses[0];
};

export const getResultingStatusDisplay = (status) => {
  switch (status) {
  case RESULTING_STATUS_TYPES.RESULTED:
    return { label: 'Resulted', variant: 'blue' };
  case RESULTING_STATUS_TYPES.PENDING_RESULTING:
    return { label: 'Pending resulting', variant: 'default' };
  case RESULTING_STATUS_TYPES.RESULT_AMENDED:
    return { label: 'Amended', variant: 'white' };
  case RESULTING_STATUS_TYPES.NOT_RESULTED:
    return { label: 'Not resulted', variant: 'default' };
  default:
    return { label: '-', variant: 'white' };
  }
};

export const getSpecialMappingLabels = (special) => {
  const eventNames = compact(map(special?.events?.nodes, 'eventName'));
  const competitionNames = compact(map(special?.competitions?.nodes, 'competitionName'));
  return [...eventNames, ...competitionNames];
};

export const isSpecialSuspended = (special) => toUpper(special?.offeringStatus || '') === 'SUSPENDED';

export const isSelectionSuspended = (selection) => toUpper(selection?.offeringStatus || '') === 'SUSPENDED';

export const isSelectionHidden = (selection) => {
  const { displayStatus } = selection ?? {};
  if (displayStatus == null || displayStatus === '') return false;
  return toUpper(displayStatus) !== 'ON';
};

export const isSpecialHidden = (special) => {
  const { displayStatus } = special ?? {};
  if (displayStatus == null || displayStatus === '') return false;
  return toUpper(displayStatus) !== 'ON';
};

export const isSpecialDisabled = (special) => !!special?.disabled;

export const mapSocketSpecialToListItem = (existingSpecial, socketSpecial) => {
  if (!socketSpecial?.specialId) return existingSpecial;

  const selections = socketSpecial.selections != null
    ? socketSpecial.selections
    : existingSpecial?.selections;

  return {
    ...existingSpecial,
    specialName: socketSpecial.specialName ?? existingSpecial?.specialName,
    resultedAfter: socketSpecial.resultedAfter ?? existingSpecial?.resultedAfter,
    offeringStatus: socketSpecial.offeringStatus ?? existingSpecial?.offeringStatus,
    displayStatus: socketSpecial.displayStatus ?? existingSpecial?.displayStatus,
    resultingStatus: socketSpecial.resultingStatus ?? existingSpecial?.resultingStatus,
    source: socketSpecial.source ?? existingSpecial?.source,
    selections,
    suspensionFlag: socketSpecial.suspensionFlag ?? existingSpecial?.suspensionFlag,
    competitions: existingSpecial?.competitions,
    events: existingSpecial?.events,
    disabled: existingSpecial?.disabled,
  };
};
